import React, { useContext, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MatchSmallElement } from "../../../../../config/types";
import { AppDispatch, RootState } from "../../../../../store";
import { fetchLeagueMatches } from "../../../../../store/actions/matchActions";
import MatchTile from "../../MatchTile";
import RoundedRectangle from "../../../RoundedRectangle";
import { ClavaContext } from "../../../../../config/contexts";
import { pathLeagueView } from "../../../../../config/routes";


type Props = {
  title: string;
  leagueId: number;
  matchDayOverride: number;
};

const MatchDayPanel: React.FC<Props> = ({ title, leagueId, matchDayOverride }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { aoi } = useContext(ClavaContext);
  const matchElements = useSelector<RootState, RootState["match"]["leagueMatches"]>((s) => s.match.leagueMatches);
  const navigate = useNavigate();


  useEffect(() => {
    if (!matchElements[`${leagueId}`]) {
      fetchLeagueMatches(dispatch, leagueId);
    }
  }, [dispatch, leagueId, matchElements, aoi]);

  const matches = useMemo<MatchSmallElement[]>(
    () => (matchElements[`${leagueId}`] ?? [])?.filter(m => m.matchDay === matchDayOverride),
    [matchElements, leagueId, matchDayOverride]
  );

  const handleTitleClick = () => {
    navigate(pathLeagueView(leagueId, "table"));
  };

  return (
    <RoundedRectangle
      className="w-full bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
      hasBorder hasTitle={false}>
      <div className="pt-4 px-4 w-full">
        <button
          type="button"
          onClick={handleTitleClick}
          className="text-left w-full"
        >
          <h6
            className="text-base font-medium text-font dark:text-font-dark hover:text-primary dark:hover:text-primary transition-colors cursor-pointer">{title}</h6>
        </button>
      </div>
      <div className="pb-4 px-4 mt-2">
        {matches.map((m: MatchSmallElement) => (
          <MatchTile
            key={`matchday-item-${m.id}`}
            match={m}
            banner="date-league"
          />
        ))}
        {matches.length === 0 && (
          <div className="tablet-panel-title">
            <span className="font-medium text-center pr-2 text-font dark:text-font-dark text-xs">-</span>
          </div>
        )}
      </div>
    </RoundedRectangle>
  );
};

export default MatchDayPanel;


